import React from 'react';
import Layout from '../components/layout';
import WhyWisedoc from '../components/whyWisedoc';
import FAQSection from '../components/home/shared/faqSections';
import HeroFeature from '../components/home/shared/heroFeaturePages';
import CompanyLogos from '../components/home/shared/companyLogos';
import WhyWisedocFeatures from '../components/home/shared/whyWisedocFeatures';
import Carousel3D from '../components/home/shared/3d-carousel';
import {
  BulbIcon,
  DocIcon,
  TemplateIcon,
} from '../components/home/shared/whyWisedocFeatures/common/svgIcons';

const data = {
  content: {
    children: [
      {
        Key: 1,
        imgUrl:
          'https://gatsby.wisedoc.net/homepage/CoverLetter_Feature_01.png',
        heading1: 'ATS FRIENDLY TEMPLATES',
        subHeading1: 'Create ATS friendly cover letters',
        text: 'Wisedoc helps you build your cover letter from the ground up — with smart, ATS-friendly formatting built in.',
        button1: 'Learn More',
        alt: 'Cover Letter Feature - ATS Templates',
      },
      {
        Key: 2,
        imgUrl:
          'https://gatsby.wisedoc.net/homepage/CoverLetter_Feature_02.png',
        heading1: 'EXPERT TIPS',
        subHeading1:
          'Utilize expert tips provided by Wisedoc to draft your cover letter',
        text: 'Use expert-backed tips from Wisedoc to craft a compelling, professional cover letter with confidence.',
        button1: 'Learn More',
        alt: 'Cover Letter Feature - Expert Tips',
      },
      {
        Key: 3,
        imgUrl:
          'https://gatsby.wisedoc.net/homepage/CoverLetter_Feature_03.png',
        heading1: 'EXPORT AS DOCX/PDF',
        subHeading1: 'Need PDF or DOCX? Wisedoc gives you both — no hassle',
        text: 'We know some job applications require DOCX, while others prefer PDF — Wisedoc lets you export your resume in both formats with ease.',
        button1: 'Learn More',
        alt: 'Cover Letter Feature - Export Options',
      },
    ],
  },
  Headings: {
    children: [
      {
        heading1: 'Key AI Resume Review Features',
        subHeading1:
          'Writing a great cover letter is no longer a struggle — Wisedoc guides you every step of the way with smart suggestions and effortless customization.',
      },
    ],
  },
};

const wisedocFeatures = {
  title: 'Why Wisedoc Cover Letter Builder',
  items: [
    {
      title: 'ATS-Friendly templates',
      description:
        'Wisedoc cover letters are optimized for ATS, ensuring your application gets to the top of the pile — ultimately increasing your chances of getting hired.',
      icon: <DocIcon />,
    },
    {
      title: 'Expert tips',
      description:
        'Say goodbye to endless Google searches on "how to write a cover letter." Our service provides expert tips alongside our cover letter builder.',
      icon: <BulbIcon />,
    },
    {
      title: 'Download as docx/pdf',
      description:
        'Don’t settle for just PDF — download your resume in DOCX format too.',
      icon: <TemplateIcon />,
    },
  ],
};

const faqs = [
  {
    question: 'What are the benefits of using an AI-powered resume builder?',
    answerLine:
      'AI resume builders like Wisedoc streamline the job application process by automatically generating personalized, professional, and ATS- friendly resumes. They save time, improve formatting, suggest impactful language, and help align your resume with specific job descriptions — all without needing design or writing skills.',
  },
  {
    question: 'Can AI help improve or update my existing resume?',
    answerLine:
      'Yes! Wisedoc can enhance your current resume by analyzing it against job descriptions and industry standards. The AI offers suggestions to improve formatting, wording, and keyword optimization — making your resume more competitive and likely to pass applicant tracking systems (ATS).',
  },
  {
    question: 'Will hiring managers know if I used AI to create my resume?',
    answerLine:
      'No. Wisedoc generates human-like, personalized content that reflects your unique skills and experience. It doesnʼt produce generic or templated language, so your resume reads naturally and professionally — without revealing it was built using AI.',
  },
  {
    question: 'Why is it important to use a resume checker before applying?',
    answerLine:
      'A resume checker helps identify critical issues like poor formatting, spelling errors, weak language, or missing keywords. Wisedocʼs built-in resume checker ensures your document is tailored, polished, and optimized to pass both human and ATS screening before you hit "submit." ',
  },
  {
    question: 'What does ATS mean and why does it matter for your resume?',
    answerLine:
      "ATS stands for Applicant Tracking System, a software recruiters use to screen resumes. If your resume isn't properly formatted or doesnʼt include relevant keywords, it may be rejected automatically. Wisedoc helps ensure your resume is ATS-compliant so it gets seen by real people.",
  },
  {
    question: 'What is a good score to pass ATS resume screening?',
    answerLine:
      'A good ATS score typically falls above 80%, meaning your resume closely matches the job description and uses appropriate keywords. Wisedoc helps you improve your ATS score by aligning your content with each jobʼs requirements and industry language.',
  },
  {
    question: 'How does Wisedoc tailor my resume to specific job descriptions?',
    answerLine:
      'Wisedoc analyzes your target job description and adjusts your resume content to match relevant keywords, skills, and qualifications. This helps improve alignment, making your resume more attractive to recruiters and increasing your chances of passing ATS filters.',
  },
  {
    question: 'How to make an ATS-friendly resume',
    answerLine:
      'To create an ATS-friendly resume, use simple formatting, standard fonts, clear headings, and avoid graphics or tables. Include relevant keywords from the job description, and keep the structure consistent. Wisedoc automates all of this to help you build an optimized, ATS-ready resume with ease.',
  },
  {
    question:
      'Does Wisedoc offer resume templates for specific industries or job roles?',
    answerLine:
      'Yes! Wisedoc offers a wide range of industry-specific resume templates, including options for tech, finance, marketing, healthcare, and more. These templates are designed to highlight the skills and experience recruiters in each field expect to see.',
  },
  {
    question: 'Does Wisedoc help with cover letters too?',
    answerLine:
      " Yes, Wisedoc includes an AI-powered Cover Letter Generator that helps you create personalized, professional cover letters in seconds. Simply input a few job specific details, and our AI crafts a compelling letter that aligns with your resume and highlights your unique value. It's perfect for tailoring cover letters to each FAQʼs  2 application — saving time while improving your chances of making a strong first impression.",
  },
  {
    question: 'Can Wisedoc improve my LinkedIn profile?',
    answerLine:
      'Definitely! Wisedoc features a LinkedIn Profile Optimizer that analyzes your current profile and provides actionable suggestions to boost visibility and credibility. It helps you rewrite your headline, summary, work experience, and skills using SEO best practices so your profile ranks higher in recruiter searches and reflects your professional brand more clearly.',
  },
  {
    question: 'What makes Wisedoc different from other resume builders?',
    answerLine:
      'Wisedoc isnʼt just a resume builder — itʼs an all-in-one AI career platform that supports the entire job search journey. From creating tailored resumes and cover letters to optimizing LinkedIn and preparing for interviews, Wisedoc gives you professional-grade tools at an affordable price. It combines intelligent automation, customization, and real-time guidance to deliver better job search results faster than traditional resume tools.',
  },
  {
    question: 'How quickly can I create a resume on Wisedoc?',
    answerLine:
      "With Wisedoc, you can create a polished, job-ready resume in under 10 minutes. Our platform offers user-friendly templates and AI-generated content suggestions that adapt to your background and the job you're applying for. You donʼt need to start from scratch — just fill in your details, and Wisedoc will help you format, phrase, and optimize your resume quickly.",
  },
  {
    question: 'Can I customize my resume for different jobs?',
    answerLine:
      "Yes! Wisedoc makes it easy to create multiple resume versions tailored to specific roles or industries. The platform allows you to duplicate and modify resumes for different job descriptions, with AI suggestions that highlight the most relevant skills and experiences — increasing your chances of passing Applicant Tracking Systems (ATS) and catching recruiters' attention.",
  },
  {
    question: 'Is my data safe with Wisedoc?',
    answerLine:
      'Absolutely. Wisedoc is committed to user privacy and data protection. Your information is stored securely and is never sold or shared with third parties. You maintain full control over your data at all times, and you can delete your documents or account whenever you choose.',
  },
  {
    question: 'Do I need any design or writing skills to use Wisedoc?',
    answerLine:
      "Not at all. Wisedoc is built for users of all skill levels. Whether you're a student or an experienced professional, our intuitive platform and AI writing assistant handle the formatting, phrasing, and structure for you. All you have to do is follow simple prompts — no design or copywriting experience required.",
  },
  {
    question: 'Can I download and export my resume?',
    answerLine:
      'Yes, Wisedoc allows you to download your resume in high-quality PDF format thatʼs ready to submit on job portals, email applications, or print. You can preview your resume before exporting to ensure everything looks perfect and customize it as needed.',
  },
  {
    question: 'Does Wisedoc offer interview preparation tools?',
    answerLine:
      'Yes, Wisedoc includes a built-in Interview Prep Assistant that helps you prepare with practice questions, structured feedback, and AI-generated suggestions. Whether youʼre prepping for behavioral questions or role-specific scenarios, Wisedoc helps boost your confidence and performance before the real interview.',
  },
  {
    question: 'Is Wisedoc suitable for students and recent graduates?',
    answerLine:
      ' Absolutely! Wisedoc offers resume and cover letter templates specifically designed for students, freshers, and recent graduates. Our platform helps you highlight academic projects, internships, skills, and coursework effectively — even if you have limited professional experience.',
  },
  {
    question: 'How can Wisedoc help me get more job callbacks?',
    answerLine:
      "Wisedoc helps increase job callbacks by making sure your resume, cover letter, and LinkedIn profile are all optimized for the roles you're applying to. Our AI tools align your application materials with job descriptions and industry standards, FAQʼs 4 improving both ATS compatibility and human readability — giving you a competitive edge in todayʼs job market.",
  },
];

const dataVideo = {
  content: {
    children: [
      {
        Key: 1,
        heading1: 'BUILD AND OPTIMIZE COVER LETTERS',
        subHeading1: 'Create ATS friendly cover letters',
        text: 'Checkout the short tutorial on building your ATS friendly cover letter!',
        button1: 'Learn More',
        alt: 'AI Resume Builder',
        isVideo: true,
        videoUrl: 'https://www.youtube.com/embed/BPgFY9B48lg',
      },
    ],
  },
  Headings: {
    children: [
      {
        heading1: 'How to Use Wisedoc’s Cover Letter Builder',
      },
    ],
  },
};

const heroData = {
  title: 'Cover Letter Builder – Say More Than “Attached is My Resume”',
  subTitle:
    'Wisedoc helps you create personalized, job-specific cover letters that actually get read — and remembered.',
  src: 'https://gatsby.wisedoc.net/homepage/Cover_Letter_Builder.png',
};

const CoverLetterBuilder = ({ location }) => {
  return (
    <Layout location={location}>
      <HeroFeature appType="GATSBY" data={heroData} />
      <CompanyLogos bgColor="#efecff" />
      <WhyWisedocFeatures data={wisedocFeatures} />
      <Carousel3D bgColor="#fcfcff" />
      <WhyWisedoc data={dataVideo} bgColor="#FCFCFF" />
      <WhyWisedoc data={data} bgColor="#FCFCFF" />
      <FAQSection faqs={faqs} />
    </Layout>
  );
};

export default CoverLetterBuilder;
